/**
 * @file コンポーネント：リストトグルアイテム スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledItem = styled.li`
    border-bottom: 1px solid #acadae;

    &:last-of-type {
        border-bottom: none;
    }
`;

export const StyledItemChildrenlist = styled.ul`
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 0.15, max-height 0.15;

    &.is-open {
        opacity: 1;
        max-height: inherit;
    }
`;

export const StyledItemChildrenlistItem = styled.li`
    border-bottom: 1px solid #acadae;

    &:first-of-type {
        border-top-width: 1px;
    }

    &:last-of-type {
        border-bottom: none;
    }
`;

export const StyledItemChildrenlistItemAnchor = styled.a`
    display: block;
    position: relative;
    padding: 14px 24px 14px 14px;
    color: #acadae;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 24px;
        height: 24px;
        margin: auto 0;
        line-height: 24px;
        text-align: center;
        content: "\f054";
    }

    &.is-active {
        color: #acadae;
        font-weight: bold;
    }
`;

export const StyledItemToggle = styled.a`
    display: block;
    position: relative;
    padding: 14px 24px 14px 0;
    color: #acadae;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 24px;
        height: 24px;
        margin: auto 0;
        line-height: 24px;
        text-align: center;
        content: "\f067";
    }

    &.is-open {
        &::after {
            content: "\f068";
        }
    }
`;
